import { mutatorAction } from 'satcheljs';
import { getFolderTable } from 'owa-folders';

export default mutatorAction('setFolderName', function setFolderName(
    folderId: string,
    name: string
) {
    getFolderTable().get(folderId).DisplayName = name;
});
